import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  imports: [CommonModule, TranslateModule],
  standalone: true,
})
export class LoadingComponent {
  @Input() width = 80;
  @Input() hide: boolean = false;
  @Input() hideText: boolean = false;
  @Input() text: string = '';
}
